module.exports = __webpack_public_path__ + "img/tachometer-fast.6d682eb2.svg";